'use strict';

/* ========================================================
 * 		Requires
 ========================================================= */
// Polyfills
require('./polyfills/requestAnimationFrame.js');

// JQuery, and Animation Code
var $ = window.jQuery;

// Lib
require('./lib/a4jAjaxEvents.js');
var Forms = require('./lib/Forms.js');

// Components
var MobileMenu 			= require('./site/MobileMenu.js');
var AddClassOnScroll 	= require('./site/AddClassOnScroll.js');
var LoadingScreen		= require('./components/LoadingScreen.js');
var GalleryBox			= require('./components/GalleryBox.js');
var MastheadSlider  	= require('./components/MastheadSlider.js');
var EmployeeBox 		= require('./components/EmployeeBox.js');
var Map					= require('./components/Map.js');
var Masonry				= require('./components/Masonry.js');
var Salvattore 			= require('salvattore');


/* ========================================================
 * 		Setup
 ========================================================= */
var $win = $(window);
var $body = $(document.body); 

//Pages -------------------------------------------------
var insights = require('./site/pages/insights.js');
insights.load();

/* ========================================================
 * 		Component Setup
 ========================================================= */
MobileMenu.init();
AddClassOnScroll.init();
Masonry.init();

// Forms setup
Forms.init();

LoadingScreen.init();
GalleryBox.init();
MastheadSlider.init();
EmployeeBox.init();

/* relies on query mask set in the master-template.xhtml file */
$('form input[type="tel"]').mask('(000) 000-0000');
$('#contact\\:extension').mask('00000');
